import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { FaEdit } from "react-icons/fa";
import { useGetOffersList } from "../hooks/useOffers";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";

interface OffersListProps {
  setSelectedRowData: (row: any) => void;
  setIsModalOpen: any;
  setModalStatus: any;
}

const OffersList: React.FC<OffersListProps> = ({
  setSelectedRowData,
  setIsModalOpen,
  setModalStatus,
}) => {
  const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    limit: 10,
    page: 1,
    search: null,
  });
  const OfferListColumns = (handleEditClick: (row: any) => void) => [
    {
      name: "Org Unit",
      selector: (row: any) => row?.OrgUnit?.UnitName || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Offer Title",
      selector: (row: { Title: string }) => row?.Title || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row: { Description: string }) => row?.Description || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Start Date",
      selector: (row: { StartDate: string }) => row?.StartDate || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "End Date",
      selector: (row: { EndDate: string }) => row?.EndDate || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row: { action: string }) => (
        <button
          onClick={() => handleEditClick(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "15px",
            padding: "5px 10px",
            width: "fit-content",
            alignItems: "center",
            gap: "5px",
            display: "flex",
          }}
        >
          <FaEdit
            style={{
              fontSize: 15,
              fill: "#ffffff",
            }}
          />
          Edit
        </button>
      ),
    },
  ];

  const { data: offersListData, isLoading: offerListDataLoading } =
    useGetOffersList({
      enable: true,
      params: {
        start: filtersState?.page,
        length: filtersState?.limit,
        search: filtersState?.search,
        orgUnitId: filtersState?.orgUnits,
      },
    });

  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  const formattedOrgUnitData = [
    { id: "", label: "All" },
    ...Object.entries(orgUnitsData?.data || {}).map(
      (item: any, index: any) => ({
        id: item[0],
        label: item[1],
      })
    ),
  ];

  const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };

  const handleEditClick = (row: any) => {
    setSelectedRowData(row);
    setIsModalOpen(true);
    setModalStatus("Edit");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  return (
    <div>
      <BasicDataTable
        dynamicHeightOnRowsPerPage={true}
        Title="Offer List"
        columns={OfferListColumns(handleEditClick)}
        showSpinner={offerListDataLoading}
        data={offersListData?.data?.data || []}
        headerContent={
          <div>
            <RoundedDropdown
              options={formattedOrgUnitData || []}
              onSelect={(e) => {
                handleFilter("orgUnits", e);
              }}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Org Unit"
              headingColor="#2e8dd3"
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={offersListData?.data?.recordsTotal || 0}
      />
    </div>
  );
};

export default OffersList;
